import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

export const getHotjarSettingsValues = (): Record<string, string> => {
  return getGlobalProperty("hotjarSettingsValues") || {};
};
